import Keycloak from 'keycloak-js';

// Keycloak is reverse-proxied on the same origin as the app in every deployed
// environment (see Caddyfile), so falling back to window.location.origin lets
// one build serve multiple domains without baking a single hostname into
// KEYCLOAK_URL. Local dev still overrides it (Keycloak runs on a different
// port there), so the env var takes precedence when set.
export default new Keycloak({
  url: window.KEYCLOAK_URL || window.location.origin,
  realm: 'lanebids',
  clientId: 'lanebids-app',
});
